import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinarySymptomFetchAction from './veterinarySymptomFetch.action.json' with { type: 'json' }
import { veterinarySymptomObject } from '../veterinarySymptomObject'

const veterinarySymptomFetchDefinition = defineAction({
  ...veterinarySymptomFetchAction,

  input: z.object({
    id: z.string().uuid(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: veterinarySymptomObject,
})

export default veterinarySymptomFetchDefinition
